import request from "@/utils/request";

export function FaceTips(data) {
  return request({
    url: "/merchant/face/count",
    method: "post",
    data: data
  });
}
